<template>
  <div id="header">
    <div id="banner">
      <div>
        <img id="salesforcelogo" src="dist/SalesforceLogo.svg"/>
        <div id="title">
          <h1>Service Cloud Snap-ins</h1>
          <h2>iOS Reference Documentation</h2>
        </div>
        <p>To learn how to use this SDK, see the <a href="https://developer.salesforce.com/docs/atlas.en-us.noversion.service_sdk_ios.meta/service_sdk_ios/servicesdk_ios_dev_guide.htm">Snap-ins Developer's Guide for iOS</a>.</p>
        <p>To see the release notes, check out our <a href="https://github.com/forcedotcom/ServiceSDK-iOS/releases">Release Notes page</a>.</p>
      </div>
    </div>
  </div>
</template>

<script>
import salesforcelogo from "file-loader?name=SalesforceLogo.svg!./assets/SalesforceLogo.svg"

export default {
  name: 'dashboard-header',
  data () {
    return {
      salesforcelogo: salesforcelogo
    }
  }
};
</script>

<style>

#header {
  position: relative;
  height: 600px;
  padding: 60px;
  background: #ffffff;
}

#banner {
  position: relative;
  width: 100%;
  top: 50%;
  left: 50%;
  margin-top: -0.8em;
  transform: translate(-50%, -50%);
  z-index: 2;
}

#salesforcelogo {
  width: 140px;
  height: auto;
  margin: 1em;
  display: inline-block;
  vertical-align: middle;
}

#title {
  display: inline-block;
  vertical-align: middle;
}

h1 {
  font-weight: normal;
  font-size: 2em;
  margin: 0;
}

h2 {
  font-weight: normal;
  font-size: 1.325em;
  margin: 0;
  color: #7a7a7a;
}

</style>



// WEBPACK FOOTER //
// DashboardHeader.vue?46900510